<template>
  <DBox
    :id="'cmp-distribution-suppliers-sidewindow-supplier-setup'"
    :addButton="false"
    :addLink="false"
  >
    <TextField2
      :id="'supplier_name'"
      :placeholder="$t('supplier_name')"
      :label="$t('supplier_name')"
      :value="supplier.supplier_name"
      @blur="onTextFieldValueChange"
    />

    <Dropdown2
      :label="$t('supplier_type')"
      :placeholder="$t('supplier_type')"
      :options="supplierTypeTV"
      :selected="supplierTypeTV.find(
          (e) => e.value == selectedSupplierDetails.supplier.supply_order_type
        )
      "
      v-on:selectedChange="(e) => onDropdownChange('supply_order_type', e)"
    />

     <Dropdown2
      :label="$t('invoice_project')"
      :options="invoiceProjectTV"
      :selected="invoiceProjectTV.find(
          (e) => e.value == selectedSupplierDetails.supplier.invoice_project_id
        )
      "
      :placeholder="$t('invoice_project')"
      v-on:selectedChange="(e) => onDropdownChange('invoice_project_id', e)"
    />
    <Dropdown2
      :label="$t('currency')"
      :placeholder="$t('currency')"
      :options="currencyTV"
      :selected="currencyTV.find(
          (e) => e.value == selectedSupplierDetails.supplier.currency_id
        )
      "
      :bb="'0px'"
      v-on:selectedChange="(e) => onDropdownChange('currency_id', e)"
    />
  </DBox>
</template>

<script>
import { createTV } from '../../../../models/text-value.model';
export default {
  props: ["selectedSupplierDetails"],

  computed: {
    supplierTypeTV: function () {
      return [
        { text: "Manufacturing", value: 1 },
        { text: "Purchase Order", value: 2 },
        { text: "Purchase Return", value: 3 },
        { text: "Defects Credit", value: 4 },
        { text: "Consignment", value: 5 },
        { text: "Consignment Return", value: 6 },
        { text: "Defects Consignment", value: 7 },
      ];
    },
    supplier: function () {
      return this.selectedSupplierDetails.supplier || {};
    },

    invoiceProjectTV:function(){
      return createTV(this.selectedSupplierDetails.invoice_projects,'invoice_project_name','invoice_project_id')
    },

    currencyTV:function(){
      return createTV(this.selectedSupplierDetails.currencies,'currency_iso','currency_id')
    }
  },
  watch: {},

  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      console.log("name", name, value.value);
      this.$emit("changed", { name, value: value.value });
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-royalty_accounts-account_setup {
  .form-group .input_box {
    padding: 0px 5px;
  }
  .fc2-row {
    //--fc2-tf-padding: 0px 0px;
    //--fc2-tf-margin: 3px 3px 3px 0px;
    --bb: 1px solid var(--sprt-85);

    height: 30px;
    border-bottom: var(--bb);

    .fc2-label,
    .icon,
    .title {
      flex: 1;
    }
    .fc2-label,
    .title-txt {
      max-width: 115px;
    }
    > .ut-flex {
      flex: 1;
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      outline: none;

      &.no-left-padding {
        padding-left: 0;
      }

      span {
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
    .icon {
      min-height: 22px;
      justify-content: flex-end;
    }

    .dropdown-2 {
      flex: 1;
    }

    .no-label {
      .fc2-label {
        display: none;
      }
    }
    .circle {
      margin-left: 10px;
    }
  }
}
</style>